import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=11fba2ca&scoped=true"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fba2ca",
  null
  
)

export default component.exports